import { FilterBoxes } from 'src/models/filter';

import { Callback } from 'src/util/query/models/Callback';

import { DocumentListCallbackStoreContract } from '../interfaces';

export class GetTheStandardDocumentModuleBoxForTheUserCallBack extends Callback<FilterBoxes> {
	public constructor(private readonly store: DocumentListCallbackStoreContract) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: FilterBoxes): void => {
		this.store.setStandardBox(successResponse);
	};
}
